import { render, staticRenderFns } from "./PageListTool.vue?vue&type=template&id=b1e534a0&scoped=true&"
import script from "./PageListTool.vue?vue&type=script&lang=ts&"
export * from "./PageListTool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e534a0",
  null
  
)

export default component.exports